import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ToolbarCanvasState } from './toolbarCanvas.types';

const initialState: ToolbarCanvasState = {
  isManualZoom: false,
};

const toolbarCanvasSlice = createSlice({
  name: 'toolbarCanvas',
  initialState,
  reducers: {
    updateManualZoom: (state, action: PayloadAction<boolean>) => {
      state.isManualZoom = action.payload;
    },
  },
});

export const { updateManualZoom } = toolbarCanvasSlice.actions;

export default toolbarCanvasSlice.reducer;
